
export const getOrderParams = ( selected ) => {
	let orderby, order;
	switch ( selected ) {
	case 'default':
		orderby = 'date';
		order = 'desc';
		break;
	case 'name_asc':
		orderby = 'title';
		order = 'asc';
		break;
	case 'name_desc':
		orderby = 'title';
		order = 'desc';
		break;
	case 'price_desc':
		orderby = 'price';
		order = 'desc';
		break;
	case 'price_asc':
		orderby = 'price';
		order = 'asc';
		break;
	case 'rating_desc':
		orderby = 'rating';
		order = 'desc';
		break;
	case 'rating_asc':
		orderby = 'rating';
		order = 'asc';
		break;
	default:
		orderby = 'date';
		order = 'desc';
		break;
	}

	return { orderby, order };
};

